<template>
<div>
  <div class="h-panel">
    <b-button v-b-modal.help-modal>Help</b-button>

    <b-button
      :to="{name: 'push_add'}"
      variant="primary"
    >
      New push
    </b-button>
  </div>

  <p v-if="message !== null">
    {{message}}
  </p>

  <template
    v-if="pushes !== null && pushes.length > 0"
  >
    <p class="mb-3">
      Push amount: {{pushes.length}}
    </p>

    <push-preview
      v-for="push in pushes"
      :key="push.id"
      :push="push"
      class="mb-3"
    />
  </template>

  <loading-indicator
    v-if="isLoading && pushes === null"
  />

  <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
    <div class="help">
      <p>
        Пользовательские  пуш-оповещения<br>
        На данной странице показаны все пуш-оповещения,
        которые были созданы пользователями инсайдера (а&nbsp;не&nbsp;автоматически).
      </p>
    </div>
  </b-modal>

</div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { genTraceId           } from '../util.js';
import { TRACE_ID_HEADER_NAME } from '../util.js';

import LoadingIndicator from './LoadingIndicator.vue';
import PushPreview from './PushPreview.vue';

import { processError } from '../controller/error_controller.js';

// Пуш-оповещения пользовательские (пуш-оповещения, которые созданы пользователями инсайдера).
// This page contains pushes, created by insider users.
// This page does not contain pushed, created automatically.
export default {
  name: 'PushesUser',

  components: {
    LoadingIndicator,
    PushPreview,
  },

  data() {
    return {
      isLoading: false,
      pushes: null,

      updateTimeoutId: null,

      /** @type {?AbortController} */
      loadingAbortController: null,
    };
  },

  computed: {
    /** @returns {?string} */
    message() {
      if(this.pushes !== null && this.pushes.length === 0) {
        return 'No push notifications.';
      }
      return null;
    },
  },

  created() {
    this.loadingAbortController = new AbortController();
    this.loadPushes();
  },

  beforeDestroy() {
    if(this.loadingAbortController !== null) {
      this.loadingAbortController.abort();
      this.loadingAbortController = null;
    }
    
    this.clearUpdateTimeout();
  },

  methods: {
    loadPushes() {
      if(this.loadingAbortController === null) {
        throw new Error('Can not load pushes. Pushes component already destroyed. this.loadingAbortController === null.');
      }

      this.isLoading = true;

      const url = '/push/previews/user';

      const config = {
        headers: {
          [TRACE_ID_HEADER_NAME]: genTraceId()
        },
        signal: this.loadingAbortController.signal
      };

      HTTP.get(url, config)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.pushes = data;

        this.createUpdateTimeout();
      })
      .catch(err => {
        this.isLoading = false;
        processError(err);
      });
    },

    handleUpdateTime() {
      this.clearUpdateTimeout();
      this.loadPushes();
    },

    createUpdateTimeout() {
      this.clearUpdateTimeout();

      const UPDATE_DELAY_MSEC = 1000;
      this.updateTimeoutId = setTimeout(this.handleUpdateTime, UPDATE_DELAY_MSEC);
    },

    clearUpdateTimeout() {
      if(this.updateTimeoutId !== null) {
        clearTimeout(this.updateTimeoutId);
        this.updateTimeoutId = null;
      }
    },
  },
}
</script>
